// @flow
import type { UtmParams } from '@rover/react-lib/types';
import appendUrlParams from '@rover/utilities/appendUrlParams';

const encodeUtmParams = (rawUtmParams: UtmParams): UtmParams => {
  const res = rawUtmParams;
  Object.keys(res).forEach(key => {
    res[key] = encodeURIComponent(rawUtmParams[key]);
  });
  return res;
};
export const addUtmParamsToUrl = (utmParams: UtmParams, url: string) => {
  if (!utmParams || !utmParams.utm_source || !utmParams.utm_source.length) return url; // utm_source is required: https://ga-dev-tools.appspot.com/campaign-url-builder/
  return appendUrlParams(url, encodeUtmParams(utmParams));
};

export { UTM_PARAMS } from './utm.constants';



// WEBPACK FOOTER //
// ../utilities/utm/index.js